export default window.__jgAppConfig;